export default __webpack_public_path__ + "static/client6-7e7a4fbf69d96294d72e5e66869657fd.png";